import type { TableServiceConfig } from '@onboarding/domain/value-objects';
import type { TableServiceApiRequest } from '@onboarding/infrastructure/api/types';

export type OnboardingApiMapperType = {
  mapTableServiceConfigToApiRequest: (config: TableServiceConfig) => TableServiceApiRequest;
};

/**
 * Creates mapper for converting between API types and domain entities.
 * Uses domain factory functions to reconstruct entities — never constructs them manually.
 */
export const createOnboardingApiMapper = (): OnboardingApiMapperType => {
  const mapTableServiceConfigToApiRequest = (config: TableServiceConfig): TableServiceApiRequest => ({
    displayTableSelection: config.hasTableService,
    requireTableSelection: config.hasTableService,
    requireOccupationSelection: false,
    useCoursing: false,
  });

  return { mapTableServiceConfigToApiRequest };
};
